import { useState } from "react";
import axios, { AxiosProgressEvent } from "axios";
import { v4 as uuid } from "uuid";
import {useLazyGetAwsFileCourierPolicyQuery,
} from "services/api/api.slice";
import { useDispatch } from "./redux";
import { setNotification } from "services";
import {FileCourierUploadFileProps} from "../interfaces/FileCourier";

const useS3FileCourierUpload = () => {
  const dispatch = useDispatch();
  
  const [callGetFileCourierPolicy, { isFetching }] = useLazyGetAwsFileCourierPolicyQuery();
  const [loading, _setLoading] = useState<boolean>(false);
  const onSuccess = async (
    awsPolicy: any,
    newFile: File | null,
    handleSuccess: Function,
    packageId: string,
    progressCallback?: Function
  ) => {
    if (newFile) {
      const fileExtension = newFile.name.split(".").pop();
      const fileUuid = uuid(),
        extension = fileExtension ? fileExtension.toLowerCase() : "png",
        fileName = newFile.name,
        mimeType = newFile.type,
        size = newFile.size,
        bodyFormData = new FormData();
      
      const uploadLocation = `${awsPolicy.uploadDirectory}/${packageId}/${newFile.name}`;
      
      bodyFormData.append("key", uploadLocation);
      bodyFormData.append("AWSAccessKeyId", awsPolicy.accessKey);
      bodyFormData.append("acl", "private");
      bodyFormData.append("success_action_status", "201");
      bodyFormData.append("policy", awsPolicy.policy);
      bodyFormData.append("signature", awsPolicy.signature);
      bodyFormData.append("Content-Type", newFile.type);
      bodyFormData.append(
        "Content-Disposition",
        `attachment; filename=${newFile.name}`
      );
      bodyFormData.append("file", newFile);
      await axios({
        method: "post",
        url: `https://${awsPolicy.bucket}.s3.amazonaws.com/`,
        data: bodyFormData,
        onUploadProgress: (progressEvent: AxiosProgressEvent) => {
          progressCallback && progressCallback(newFile.name, progressEvent);
        },
      })
      .then(() => {
        const response: FileCourierUploadFileProps = {
          extension,
          name: fileName,
          fileId: fileUuid,
          mimeType,
          sizeInBytes: size,
          packageId: packageId
        };
        
        _setLoading(false);
        dispatch(
          setNotification({
            type: "success",
            message: "File has been uploaded. Submit still required.",
          })
        );
        handleSuccess(response);
      })
      .catch(handleError);
    }
  };
  const handleError = (err: any) => {
    dispatch(
      setNotification({
        type: "error",
        message: "An error has occurred, please try again.",
      })
    );
    _setLoading(false);
  };
  const uploadS3 = async (
      newFile: File | null,
      handleSuccess: Function,
      packageId: string,
      progressCallback?: Function
    ) => {
      _setLoading(true);
      await callGetFileCourierPolicy()
      .unwrap()
      .then((awsPolicy: any) =>
        onSuccess(
          awsPolicy,
          newFile,
          handleSuccess,
          packageId,
          progressCallback
        )
      )
      .catch(handleError);
    };
    
  
  return { uploadS3, loading: loading || isFetching };
};

export default useS3FileCourierUpload;
